/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SegmentValue } from './SegmentValue';
import type { TeamSegment } from './TeamSegment';

export type NumericScoreWithPromptDetails = {
    /**
     * * `PROMPT` - PROMPT
     * * `SUBTOPIC` - SUBTOPIC
     * * `TOPIC` - TOPIC
     */
    type: NumericScoreWithPromptDetails.type;
    /**
     * Can refer to a CanonicalTopic, CanonicalSubtopic, CanonicalPrompt or CustomerPrompt, based on `type`.
     */
    slug: string;
    scaledAvg: number;
    'n': number;
    freqDist: Array<number>;
    /**
     * For matrix prompts: stores individual row scores as {row_label: {scaled_avg, n, freq_dist}}
     */
    rowScores?: any;
    teamSegment?: TeamSegment;
    segment?: SegmentValue;
    promptParentSlug?: string;
    /**
     * * `RATING_5L` - RATING_5L
     * * `RATING_5N` - RATING_5N
     * * `SINGLE_SEL` - SINGLE_SEL
     * * `MULTI_SEL` - MULTI_SEL
     * * `OPEN_END` - OPEN_END
     * * `MATRIX_N` - MATRIX_N
     * * `MATRIX_L` - MATRIX_L
     * * `NPS` - NPS
     */
    promptType?: NumericScoreWithPromptDetails.promptType;
    promptFlags?: Array<string>;
    promptText?: string;
    promptRowLabels?: Array<string>;
    promptTopicSlug?: string;
    promptTopicName?: string;
    promptSubtopicSlug?: string;
    promptSubtopicName?: string;
    name?: string;
    shortDescription?: string;
};

export namespace NumericScoreWithPromptDetails {

    /**
     * * `PROMPT` - PROMPT
     * * `SUBTOPIC` - SUBTOPIC
     * * `TOPIC` - TOPIC
     */
    export enum type {
        PROMPT = 'PROMPT',
        SUBTOPIC = 'SUBTOPIC',
        TOPIC = 'TOPIC',
    }

    /**
     * * `RATING_5L` - RATING_5L
     * * `RATING_5N` - RATING_5N
     * * `SINGLE_SEL` - SINGLE_SEL
     * * `MULTI_SEL` - MULTI_SEL
     * * `OPEN_END` - OPEN_END
     * * `MATRIX_N` - MATRIX_N
     * * `MATRIX_L` - MATRIX_L
     * * `NPS` - NPS
     */
    export enum promptType {
        RATING_5L = 'RATING_5L',
        RATING_5N = 'RATING_5N',
        SINGLE_SEL = 'SINGLE_SEL',
        MULTI_SEL = 'MULTI_SEL',
        OPEN_END = 'OPEN_END',
        MATRIX_N = 'MATRIX_N',
        MATRIX_L = 'MATRIX_L',
        NPS = 'NPS',
    }


}

